import React, { useEffect, useState } from "react";
import {
  Radio,
  FormGroup,
  FormControlLabel,
  Container,
  TextField,
  InputAdornment,
  Tooltip,
} from "@material-ui/core";
import { P1, P2, P3 } from "assets/fonts";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  row: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  label: {
    minWidth: "120px",
    fontWeight: 300,
  },
  textField: {
    marginLeft: theme.spacing(2),
    width: "200px",
  },
  maxValueField: {
    marginLeft: theme.spacing(2),
    width: "120px",
  },
  optionalGroup: {
    marginBottom: theme.spacing(2),
  },
}));

const SliderV2 = (props) => {
  const classes = useStyles();
  const { id } = props;
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState([]);
  const [left, setLeft] = useState("");
  const [right, setRight] = useState("");
  const [maxValue, setMaxValue] = useState(100);
  const [optional, setOptional] = useState(false);
  const [maxValueError, setMaxValueError] = useState("");

  useEffect(() => {
    if (id) {
      (async () => {
        const doc = await axios.get("/api/gui/sliderv2/" + id);
        setQuestion(doc.data.question);
        setOptions(doc.data.options);
        setMaxValue(doc.data.maxValue ?? 100);
        setOptional(doc.data.optional ?? false);
        if (!!doc.data.options.length && doc.data.options.length === 2) {
          setLeft(doc.data.options[0]);
          setRight(doc.data.options[1]);
        }
      })();
    }
  }, [id]);

  useEffect(() => {
    if (!!left && !!right) {
      setOptions([left, right]);
    }
  }, [left, right]);

  const handleBlur = async () => {
    await axios.put("/api/gui/sliderv2/" + id, { question, options });
  };

  const handleMaxValueChange = async (e) => {
    const value = parseInt(e.target.value);
    if (isNaN(value)) {
      setMaxValueError("Please enter a valid number");
      return;
    }
    if (value < 2) {
      setMaxValueError("Minimum value is 2");
      return;
    }
    if (value > 100) {
      setMaxValueError("Maximum value is 100");
      return;
    }
    setMaxValueError("");
    setMaxValue(value);
    await axios.put("/api/gui/sliderv2/" + id, { maxValue: value });
  };

  const handleOptionalChange = async (newBool) => {
    setOptional(newBool);
    await axios.put("/api/gui/sliderv2/" + id, { optional: newBool });
  };

  return (
    <Container className={classes.root}>
      <P1>Slider V2 (Customizable Range)</P1>
      <div className={classes.optionalGroup}>
        <FormControlLabel
          control={
            <Radio
              color="primary"
              checked={optional === true}
              onChange={(e) => handleOptionalChange(true)}
            />
          }
          label={<P3 style={{ marginTop: "10px" }}>{"Optional"}</P3>}
        />
        <FormControlLabel
          control={
            <Radio
              color="primary"
              checked={optional === false}
              onChange={(e) => handleOptionalChange(false)}
            />
          }
          label={<P3 style={{ marginTop: "10px" }}>{"Mandatory"}</P3>}
        />
      </div>
      <div className={classes.row}>
        <P2 className={classes.label}>Question:</P2>
        <TextField
          value={question}
          className={classes.textField}
          onBlur={handleBlur}
          onChange={(e) => setQuestion(e.target.value)}
          variant="outlined"
          size="small"
        />
      </div>
      <div className={classes.row}>
        <P2 className={classes.label}>Left label:</P2>
        <TextField
          value={left}
          className={classes.textField}
          onBlur={handleBlur}
          onChange={(e) => setLeft(e.target.value)}
          variant="outlined"
          size="small"
        />
        <P2 className={classes.label} style={{ marginLeft: "20px" }}>
          Right label:
        </P2>
        <TextField
          value={right}
          className={classes.textField}
          onBlur={handleBlur}
          onChange={(e) => setRight(e.target.value)}
          variant="outlined"
          size="small"
        />
      </div>
      <div className={classes.row}>
        <P2 className={classes.label}>Max Value:</P2>
        <Tooltip title="Enter a value between 2 and 100">
          <TextField
            type="number"
            value={maxValue}
            className={classes.maxValueField}
            onChange={(e) => {
              const value =
                e.target.value === "" ? "" : parseInt(e.target.value);
              setMaxValue(value);
              if (
                value === "" ||
                (!isNaN(value) && value >= 2 && value <= 100)
              ) {
                setMaxValueError("");
              }
            }}
            onBlur={handleMaxValueChange}
            error={!!maxValueError}
            helperText={maxValueError}
            variant="outlined"
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">points</InputAdornment>
              ),
              inputProps: { min: 2, max: 100 },
            }}
          />
        </Tooltip>
      </div>
    </Container>
  );
};

export default SliderV2;
